<template>
  <ProprietaireForgetPassword />
</template>

<script>
  import ProprietaireForgetPassword from "@/components/ProprietaireForgetPassword.vue";
  export default {
    name: "ProprietaireForgetPasswordPage",
    components: {
      ProprietaireForgetPassword,
    },
  };
</script>
